import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=471c6b18&scoped=true"
import script from "./sdk.vue?vue&type=script&lang=ts"
export * from "./sdk.vue?vue&type=script&lang=ts"
import style0 from "./sdk.vue?vue&type=style&index=0&id=471c6b18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c6b18",
  null
  
)

export default component.exports